import { useEffect, useState } from "react";
import { useAllContexts } from "../../../hooks/useAllContexts";
import styled from "styled-components";
import Delete from "../../../../SMARTCITY/assets/svg/close_selection.svg";
import DownArrow from "../../../../SMARTCITY/assets/svg/down_arrow.svg";
import { useTranslation } from "react-i18next";

const SensorsHeatMapButton = ({ id }) => {
  const { environment, variables, meteo } = useAllContexts();
  const { availableSensors } = environment;
  const { meteoSensors } = meteo;
  const { getSelectedSensor, setSelectedSensor } = variables;
  const [buttonData, setButtonData] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    setButtonData(id === "1" ? availableSensors : meteoSensors);
  }, [availableSensors, meteoSensors]);

  const handleSensorName = (sensor) => {
    const name = t(sensor).replace(`\n`, " ");
    return name.length > 21 ? `${name.slice(0, 21)}..` : name;
  };

  return (
    <HeatMapBtn>
      <SensorSection
        onClick={() => {
          setShowDropdown(!showDropdown);
        }}
      >
        <span>
          {getSelectedSensor
            ? handleSensorName(getSelectedSensor)
            : t("selectSensor")}
        </span>
      </SensorSection>
      <ArrowSection
        onClick={() => {
          setShowDropdown(!showDropdown);
        }}
        $isDropdownOpen={showDropdown}
      >
        <img src={DownArrow} width={14} />
      </ArrowSection>
      {getSelectedSensor && (
        <RemoveSensor
          onClick={() => {
            setSelectedSensor(null);
            setShowDropdown(false);
          }}
        >
          <img src={Delete} />
        </RemoveSensor>
      )}

      {showDropdown && (
        <Dropdown>
          {buttonData.map((sensor, id) => {
            return (
              <DropdownItem
                key={`drop_item_${id}`}
                $selectedItem={t(getSelectedSensor).replace(`\n`, " ")}
                $currentItem={t(sensor).replace(`\n`, " ")}
                onClick={() => {
                  setShowDropdown(false);
                  setSelectedSensor(sensor);
                }}
              >
                {t(sensor)}
              </DropdownItem>
            );
          })}
        </Dropdown>
      )}
    </HeatMapBtn>
  );
};

export default SensorsHeatMapButton;

const HeatMapBtn = styled.div`
  position: absolute;
  top: 10px;
  right: calc((100vw - 560px) / 2);
  z-index: 400;
  width: 280px;
  height: 40px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;

const SensorSection = styled.div`
  width: 210px;
  height: 30px;
  display: flex;
  align-items: center;
  //   background-color: blue;
  span {
    padding-left: 10px;
  }
`;

const ArrowSection = styled.div`
  width: 30px;
  height: 30px;
  // background-color: red;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ $isDropdownOpen }) =>
    $isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)"};
  transition: all 0.2s ease-in-out;
`;

const Dropdown = styled.div`
  width: 280px;
  height: 200px;
  overflow-y: auto;
  background-color: #ffffff;
  position: absolute;
  top: 46px;
  left: 0;
  border-radius: 8px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 8px;
  div:nth-child(1) {
    padding-top: 8px;
  }
  div:last-child {
    padding-bottom: 8px;
  }
  cursor: auto;
`;

const DropdownItem = styled.div`
  padding: 8px;
  background-color: ${({ $selectedItem, $currentItem }) =>
    $selectedItem === $currentItem ? "#5555551f" : "transparent"};
  &:hover {
    cursor: pointer;
    background-color: #5555551f;
  }
`;

const RemoveSensor = styled.div`
  position: absolute;
  top: 6px;
  right: 36px;
  background-color: #ffffff;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  font-weight: 600;
  z-index: 410;
`;
